import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  mobile_secondary_action: {
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 600,
    color: 'rgba(0, 0, 0, 0.85)',
  },
}));